"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Issuance = void 0;
const internal_1 = require("../../../../../internal");
const internal_2 = require("../../../../../utils/internal");
/**
 * Handles all Asset Issuance related functionality
 */
class Issuance extends internal_1.Namespace {
    /**
     * @hidden
     */
    constructor(parent, context) {
        super(parent, context);
        this.issue = (0, internal_2.createProcedureMethod)({ getProcedureAndArgs: args => [internal_1.issueTokens, Object.assign({ asset: parent }, args)] }, context);
    }
}
exports.Issuance = Issuance;
//# sourceMappingURL=index.js.map